/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable brace-style */
import React, { useState, useEffect,  useMemo, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  classNameTriskeleParser
} from '../../../utilities/customStyles';
import WeeklySkeleton from './skeleton/WeeklySkeleton';

import Error from '../../../components/Error';
import { compareDates } from '../../../utilities/dates';
import DashboardAccess from '../../../dataAccess/DashboardAccess';
import { Body2400C } from '../../../utilities/generatedClasses';
import { isTextEmpty } from '../../../utilities/utils';

// Render Data for Seven days on right side of dashboard


const renderTableElement = (selectedDate, tRow, tRowIndex, tColumnt, tColumnIndex, rowLength) => {
  const object = JSON.parse(JSON.stringify(tColumnt));

  if (tRowIndex === 0) {
    if (rowLength === 1) {
      return null;
    }
    if (typeof tColumnt !== 'string') {
      const columnClass = classNameTriskeleParser.bind(
        this,
        object.VisualName,
        object.VisualType
      );

      return (
        <th
          className={`${!isTextEmpty(object.VisualName) && !isTextEmpty(object.VisualType) ? columnClass('Text') : ''}`}
          key={tColumnIndex}
          style={{ width: '10px' }}
        >
          <span className={`${!isTextEmpty(object.VisualName) && !isTextEmpty(object.VisualType) ? columnClass('Line') : ''}`}>
            {object.text}
          </span>
        </th>
      );
    }
    
    // margin-left: 300px
    // text margin: 0 100px
    return <th key={tColumnIndex} />;
  }
  if (typeof tColumnt !== 'string') {
    const cellClass = classNameTriskeleParser.bind(
      this,
      object.VisualName,
      object.VisualType
    );
    return (
      <td
        key={tColumnIndex}
        className={`${compareDates(object.date, selectedDate, 'weeklyview') ? 'blue-line' : ''}`}
        >
        <div className={`${!isTextEmpty(object.VisualName) && !isTextEmpty(object.VisualType) ? cellClass('Circle') : ''} icon-background`}>
          <div className={`${!isTextEmpty(object.VisualName) && !isTextEmpty(object.VisualType) ? cellClass('Icon') : ''} icon-metric`} />
        </div>
      </td>
    );
  } return (
    <td key={tColumnIndex} className={`dashboard-right-side-main-column-text ${Body2400C}`}>
      {tColumnt}
    </td>
  );
};

const WeeklyView = (props) => {
  const [weeklyDashboard, setWeeklyDashboard] = useState(null);
  const [emptyState, setEmptyState] = useState(false);

  const topFilterData = useSelector(state => state.widgetFiltes);
  const selectedSevenDays = useSelector(state => state.selectedSevenDays);
  const rectangleBackgroundTriskeleClass = classNameTriskeleParser('Background', 'Off-White', 'Rectangle');

  const { clientId } = props;

  const requestKeyRef = useRef(null);
  const reqGenRef = useRef(0);

  const dateRange = useMemo(() => {
    if (!selectedSevenDays || selectedSevenDays.length < 7) return null;

    const startDate = new Date(selectedSevenDays[0].Date).toLocaleDateString('en-US');
    const endDate = new Date(selectedSevenDays[6].Date).toLocaleDateString('en-US');

    return { startDate, endDate, key: `${clientId}|${startDate}|${endDate}` };
  }, [clientId, selectedSevenDays]);

  const fetchWeeklyDashboard = useCallback(() => {
    if (!dateRange) return;

    // Deduplicate: skip if already fetched for this exact date range + client
    if (requestKeyRef.current === dateRange.key) return;
    requestKeyRef.current = dateRange.key;

    // Generation counter: discard responses from superseded requests
    const gen = ++reqGenRef.current;
    setWeeklyDashboard(null);

    DashboardAccess.getWeeklyDashboard(clientId, dateRange.startDate, dateRange.endDate)
      .then((response) => {
        if (gen !== reqGenRef.current) return; // stale response — discard

        if (response.status === 204 || !response.data || response.data.length === 0) {
          setEmptyState(true);
          setWeeklyDashboard(null);
          return;
        }

        setEmptyState(false);

        let { data } = response;
        data = data.sort((a, b) => a.MeasureSortOrdr - b.MeasureSortOrdr);

        const splitHeaderCell = data.filter(el => el.PrcsParmtrValueOne === 'Header');
        const splitDataCell = data.filter(el => el.PrcsParmtrValueOne === 'Measure');

        const rowsNames = [
          ...new Map(splitDataCell.map((item) => [item.MeasureName, item])).values(),
        ]
          .sort((a, b) => a.MeasureSortOrdr - b.MeasureSortOrdr)
          .map(el => el.MeasureName);

        const table = Array(rowsNames.length + 1)
          .fill()
          .map((_, rowIndex) =>
            Array(splitHeaderCell.length + 1)
              .fill(null)
              .map((__, columnIndex) =>
                _createTable(
                  rowIndex,
                  columnIndex,
                  splitHeaderCell,
                  splitDataCell,
                  rowsNames
                )
              )
          );

        setWeeklyDashboard(table);
      })
      .catch((error) => {
        if (gen !== reqGenRef.current) return;
        console.error(error);
        requestKeyRef.current = null; // allow retry on next effect
      });
  }, [clientId, dateRange, setEmptyState, setWeeklyDashboard]);

  // Only re-fetch when the date range changes — filter toggles only affect display, not data
  useEffect(() => {
    fetchWeeklyDashboard();
  }, [fetchWeeklyDashboard]);
  const _createTable = (
    rowIndex,
    columnIndex,
    splitHeaderCell,
    splitDataCell,
    rowsNames
  ) => {
    if (rowIndex === 0 && columnIndex === 0) {
      // => top, left cell of the table, empty
      return '';
    } if (rowIndex === 0) {
      //= > column names
      return {
        VisualName: splitHeaderCell[columnIndex - 1].VisualNameOne,
        VisualType: splitHeaderCell[columnIndex - 1].VisualTypeOne,
        text: splitHeaderCell[columnIndex - 1].DayOfWeek,
      };
    } if (columnIndex === 0) {
      // => rows names
      return rowsNames[rowIndex - 1];
    }
    // => data fields

    const findDataCell = splitDataCell.find(
      el => el.Date === splitHeaderCell[columnIndex - 1].Date
          && el.MeasureName === rowsNames[rowIndex - 1]
    );

    if (!findDataCell)
    // didn't find, empty icon
    {
      return {
        VisualName: '',
        VisualType: '',
        date: splitHeaderCell[columnIndex - 1].Date
      };
    }
    return {
      // found, design data icon
      VisualName: findDataCell.VisualNameTwo,
      VisualType: findDataCell.VisualTypeTwo,
      day: findDataCell.VisualTypeOne,
      date: splitHeaderCell[columnIndex - 1].Date
    };
  };



  return (
    <div className="dashboard-right-side">
      {!weeklyDashboard && !emptyState && <WeeklySkeleton />}
      {weeklyDashboard && weeklyDashboard.length > 0 && (
      <table className="table-right-side">
        <tbody>
          {weeklyDashboard.map((tRow, tRowIndex) => (
              <tr
                key={tRowIndex}
                className={`${
                  tRowIndex % 2 !== 0 ? rectangleBackgroundTriskeleClass : ''
                }`}
              >
                {tRow
                  && tRow.map((tColumnt, tColumnIndex) => renderTableElement(topFilterData.selectedDate, tRow, tRowIndex, tColumnt, tColumnIndex, weeklyDashboard.length))}
              </tr>
            ))}
        </tbody>
      </table>
      )}
      {(emptyState || (weeklyDashboard && weeklyDashboard.length === 1))
            && (
            <Error
              kind="empty"
              line1="No Data Found"
              line2="Please add recommendations and ensure you have access to lifestyle data"
              line3="" />
            )}

    </div>
  );
};
export default WeeklyView;
